import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FieldTypes } from '../../FieldTypes';
import { FormGroup, } from '@angular/forms';

@Component({
  selector: 'vias-page-viewer',
  templateUrl: './page-viewer.component.html',
  styleUrls: ['./page-viewer.component.scss']
})
export class PageViewerComponent implements OnInit, OnChanges {
  @Input() item: FormItem;
  @Input() form: FormGroup;


  public htmlContent: string;

  @ViewChild('containerElement', {static: false}) private containerElement;
  @ViewChild('contentElement', {static: false}) private contentElement;


  constructor( private element: ElementRef ) {
  }

  ngOnInit(): void {
    if (this.item.contentComponent !== undefined){
      console.log(this.containerElement);
    } else if (this.item.htmlContent !== undefined){
      this.htmlContent = this.item.htmlContent;
    } else {
      this.htmlContent = '';
    }
  }

  ngOnChanges(changes): void {}
}
